<template>
  <q-tab-pane name="invoices" class="no-padding">
    <div class="layout-padding">
      <div v-if="hasInvoices">
        <q-btn outline color="primary" icon="add" :label="$tc('invoice', 1)" @click="handleCreateInvoice"></q-btn>
        <div class="row gutter-sm q-mt-sm">
          <div v-for="invoice in invoices" :key="invoice.id" class="col-xs-12 col-sm-6 col-md-4 col-xl-3">
            <invoice-card :invoice="invoice"/>
          </div>
        </div>
      </div>

      <template v-else>
        <div class="row justify-center items-center col-grow q-pt-lg">
          <div class="text-center">
            <img src="~assets/emptystates/invoices_empty.svg" width="40%"/>

            <h6 class="q-my-md text-faded">{{ $t('invoices_empty') }}</h6>

            <q-btn @click="handleCreateInvoice" color="primary" class="q-mt-lg" outline v-is-user>
              {{ $t('create_invoice') }}
            </q-btn>
          </div>
        </div>
      </template>
    </div>
  </q-tab-pane>
</template>

<script>
  import InvoiceCard from 'components/Invoices/InvoiceCard.vue'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      project: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters(['activeTeam']),

      invoices () {
        return this.project.invoices ? this.project.invoices.data : []
      },

      hasInvoices () {
        return !!this.invoices.length
      }
    },

    methods: {
      handleCreateInvoice () {
        this.$router.push({
          name: 'create-invoice',
          params: { teamId: this.activeTeam.id },
          query: {
            project: this.project.id
          }
        })
      }
    },

    components: {
      InvoiceCard
    }
  }
</script>
